import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DraggableDictionaryAnswer from './DraggableDictionaryAnswer';

export default class DictionaryTarget extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedTargets: [] };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ selectedTargets: [] });
    this.targets = nextProps.targetData.map(item => item.node);
  }

  getSelectedTargets = () =>
    this.props.targetData
      .filter(target => this.state.selectedTargets.indexOf(target.node) > -1)
      .map(target => ({
        ...target,
        shortText: `${
          this.props.useQuestions
            ? `${this.props.selectedTreeNode.shortText.toUpperCase()}: `
            : ''
        }${target.shortText.toUpperCase()}`,
        shortTextCatgView: target.shortText.toUpperCase(),
        recordType: target.rectype,
      }));

  selectAllTargets = () =>
    this.setState({ selectedTargets: [...this.targets] });

  handleMouseDown = (e, nodeID) => {
    if (
      e.button === 0 &&
      !e.ctrlKey &&
      !e.shiftKey &&
      !e.metaKey &&
      this.state.selectedTargets.indexOf(nodeID) < 0
    ) {
      this.setState({ selectedTargets: [nodeID] });
    }
  };
  handleMouseUp = (e, nodeID) => {
    if (e.button === 0) {
      if (e.ctrlKey || e.metaKey) {
        if (this.state.selectedTargets.indexOf(nodeID) !== -1) {
          return this.setState({
            selectedTargets: this.state.selectedTargets.filter(
              item => item !== nodeID,
            ),
          });
        }
        return this.setState({
          selectedTargets: [...this.state.selectedTargets, nodeID],
        });
      }

      if (
        e.shiftKey &&
        this.state.selectedTargets.length !== 0 &&
        this.state.selectedTargets[0] !== nodeID
      ) {
        const baseTarget = this.state.selectedTargets[0];
        if (this.targets.indexOf(baseTarget) < this.targets.indexOf(nodeID)) {
          return this.setState({
            selectedTargets: this.targets.slice(
              this.targets.indexOf(baseTarget),
              this.targets.indexOf(nodeID) + 1,
            ),
          });
        }

        const reverseTargets = this.targets.slice().reverse();
        return this.setState({
          selectedTargets: reverseTargets.slice(
            reverseTargets.indexOf(baseTarget),
            reverseTargets.indexOf(nodeID) + 1,
          ),
        });
      }
      return this.setState({ selectedTargets: [nodeID] });
    } else if (e.button === 2 && this.state.selectedTargets.length === 0) {
      this.setState({ selectedTargets: [nodeID] });
    }

    return undefined;
  };

  renderTargetItems = () =>
    this.props.targetData.map(item => (
      <div
        style={
          this.state.selectedTargets.indexOf(item.node) !== -1
            ? { background: '#cccccc', color: '#30435d' }
            : {}
        }
        data-tooltip
        aria-haspopup="true"
        data-disable-hover="false"
        title={`${
          this.props.useQuestions
            ? `${this.props.selectedTreeNode.shortText}: `
            : ''
        }${item.shortText.toUpperCase()}`}
        className="targets"
        key={item.node}
        onMouseUp={e => this.handleMouseUp(e, item.node)}
        onMouseDown={e => this.handleMouseDown(e, item.node)}
      >
        <DraggableDictionaryAnswer
          name={item.shortText.toUpperCase()}
          type={item.rectype}
          handleAnswersPreview={this.props.handleAnswersPreview}
          getSelectedTargets={this.getSelectedTargets}
          ddNHCS={item.modeled}
        />
      </div>
    ));

  render() {
    return <div>{this.renderTargetItems()}</div>;
  }
}

DictionaryTarget.propTypes = {
  targetData: PropTypes.arrayOf(PropTypes.shape({})),
  handleAnswersPreview: PropTypes.func,
  selectedTreeNode: PropTypes.shape({
    shortText: PropTypes.shortText,
  }),
  useQuestions: PropTypes.bool,
};
